/* Loumi Baby – kategori sayfası: AJAX filtre/sıralama (Section Rendering API), daha fazla göster, mobil filtre paneli.
   sections/loumi-collection.liquid ile çalışır. Alt panel kapama/kilit loumi.js (LM.openLayer, [data-lm-close]) üzerinden. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function init(root) {
    if (root.dataset.lmCReady) return;
    root.dataset.lmCReady = '1';
    const sid = root.dataset.sectionId;
    const form = $('[data-lm-c-form]', root);
    const sheet = $('[data-lm-c-sheet]', root);
    if (!form) return;

    let ctrl = null;
    let seq = 0;
    let lastQuery = query();
    let priceT;

    /* sabit header yüksekliği → yapışkan çubuk/yan sütun konumu */
    const setTop = () => {
      const h = document.querySelector('.lm-header-wrap.is-sticky');
      root.style.setProperty('--lm-c-top', (h ? h.offsetHeight : 0) + 'px');
    };
    setTop();
    window.addEventListener('resize', setTop, { passive: true });

    function query() {
      const p = new URLSearchParams();
      for (const [k, v] of new FormData(form)) {
        if (typeof v !== 'string') continue;
        const val = v.trim();
        if (val === '') continue;
        p.append(k, val);
      }
      return p.toString();
    }
    const base = () => new URL(form.getAttribute('action') || location.pathname, location.origin).pathname;

    function sectionUrl(url) {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', sid);
      return u.toString();
    }
    async function fetchDoc(url, signal) {
      const res = await fetch(sectionUrl(url), { signal, headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return new DOMParser().parseFromString(await res.text(), 'text/html');
    }

    /* filtre/sıralama değişimi: parçaları yeniden çiz */
    async function load(url) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const my = ++seq;
      root.classList.add('is-loading');
      const open = {};
      $$('details[data-lm-c-group]', root).forEach((d) => { open[d.dataset.lmCGroup] = d.open; });
      const act = document.activeElement;
      const focusKey = act && root.contains(act) && act.name ? [act.name, act.value] : null;
      try {
        const doc = await fetchDoc(url, ctrl.signal);
        if (my !== seq) return;
        $$('[data-lm-c-part]', root).forEach((el) => {
          const next = doc.querySelector(`[data-lm-c-part="${el.dataset.lmCPart}"]`);
          if (next) el.replaceWith(document.importNode(next, true));
        });
        $$('details[data-lm-c-group]', root).forEach((d) => {
          if (d.dataset.lmCGroup in open) d.open = open[d.dataset.lmCGroup];
        });
        const clean = new URL(url, location.origin);
        clean.searchParams.delete('section_id');
        clean.searchParams.delete('page');
        history.replaceState(history.state, '', clean.pathname + clean.search + clean.hash);
        lastQuery = query();
        syncSort();
        if (focusKey) {
          const f = $$('[data-lm-c-part="filters"] input', root).find((i) => i.name === focusKey[0] && (i.type === 'number' || i.value === focusKey[1]));
          if (f && f.type !== 'number') f.focus({ preventScroll: true });
        }
        if (!sheetOpen()) {
          const res = $('[data-lm-c-part="results"]', root);
          if (res) {
            const top = res.getBoundingClientRect().top;
            const off = parseInt(getComputedStyle(root).getPropertyValue('--lm-c-top'), 10) || 0;
            if (top < off) window.scrollTo({ top: window.scrollY + top - off - 80, behavior: 'smooth' });
          }
        }
        document.dispatchEvent(new CustomEvent('lm:collection:updated', { detail: { url: clean.toString() } }));
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      } finally {
        if (my === seq) root.classList.remove('is-loading');
      }
    }

    function apply() {
      const q = query();
      if (q === lastQuery) return;
      lastQuery = q;
      load(base() + (q ? '?' + q : ''));
    }

    function syncSort() {
      const d = $('[data-lm-c-sort]', root);
      const m = $('[data-lm-c-sort-m]', root);
      if (d && m) m.value = d.value;
    }

    const sheetOpen = () => !!sheet && sheet.classList.contains('is-on');
    function openSheet() {
      if (!sheet) return;
      if (window.LM && LM.openLayer) LM.openLayer(sheet);
      else { sheet.classList.add('is-on'); document.body.classList.add('lm-lock'); }
    }

    /* daha fazla göster: sonraki sayfanın kartlarını ekle */
    async function more(a) {
      if (a.classList.contains('is-loading')) return;
      a.classList.add('is-loading');
      a.setAttribute('aria-busy', 'true');
      try {
        const doc = await fetchDoc(a.href);
        const grid = $('[data-lm-c-grid]', root);
        const cards = $$('[data-lm-c-grid] > .lm-card', doc);
        if (!grid || !cards.length) throw new Error('empty');
        const first = document.importNode(cards[0], true);
        grid.appendChild(first);
        cards.slice(1).forEach((c) => grid.appendChild(document.importNode(c, true)));
        const wrap = $('[data-lm-c-more-wrap]', root);
        const nextWrap = doc.querySelector('[data-lm-c-more-wrap]');
        if (wrap && nextWrap) {
          const prev = nextWrap.querySelector('.lm-c-prev');
          if (prev) prev.remove();
          wrap.replaceWith(document.importNode(nextWrap, true));
        }
        const link = first.querySelector('a');
        if (link) link.focus({ preventScroll: true });
      } catch (e) {
        window.location.href = a.href;
      }
    }

    /* olaylar */
    form.addEventListener('submit', (e) => { e.preventDefault(); clearTimeout(priceT); apply(); });
    form.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-lm-c-sort-m]')) {
        const d = $('[data-lm-c-sort]', root);
        if (d) d.value = t.value;
        apply();
        return;
      }
      if (t.matches('[data-lm-c-price]')) { clearTimeout(priceT); apply(); return; }
      if (t.name) apply();
    });
    form.addEventListener('input', (e) => {
      if (!e.target.matches('[data-lm-c-price]')) return;
      clearTimeout(priceT);
      priceT = setTimeout(apply, 800);
    });
    root.addEventListener('click', (e) => {
      const t = e.target;
      let el;
      if ((el = t.closest('[data-lm-c-open]'))) { e.preventDefault(); openSheet(); return; }
      if ((el = t.closest('a[data-lm-c-link]'))) {
        e.preventDefault();
        const u = new URL(el.href, location.origin);
        lastQuery = u.searchParams.toString();
        load(u.pathname + u.search);
        return;
      }
      if ((el = t.closest('a[data-lm-c-more]'))) { e.preventDefault(); more(el); return; }
      if ((el = t.closest('[data-lm-c-expand]'))) {
        e.preventDefault();
        const d = $('[data-lm-c-desc]', root);
        if (d) d.classList.add('is-open');
        el.hidden = true;
        return;
      }
      if ((el = t.closest('a[data-lm-c-scroll]'))) {
        const target = document.querySelector(el.getAttribute('href'));
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        return;
      }
      if (!window.LM && (el = t.closest('[data-lm-close]')) && sheet) {
        sheet.classList.remove('is-on');
        document.body.classList.remove('lm-lock');
      }
    });

    /* açıklama: taşmıyorsa "Devamını oku" düğmesi gizli kalsın */
    const desc = $('[data-lm-c-desc]', root);
    const exp = $('[data-lm-c-expand]', root);
    if (desc && exp) exp.hidden = desc.scrollHeight <= desc.clientHeight + 2;

    /* masaüstüne geçişte açık kalan paneli kapat */
    const mq = window.matchMedia('(min-width: 961px)');
    const onMq = () => {
      if (mq.matches && sheetOpen()) {
        if (window.LM && LM.closeAll) LM.closeAll();
        else { sheet.classList.remove('is-on'); document.body.classList.remove('lm-lock'); }
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
  }

  const boot = () => $$('[data-lm-c]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => {
    const r = e.target.querySelector('[data-lm-c]');
    if (r) init(r);
  });
})();
